import { lazy } from "react";
import { RouteConfig } from "../../../types/RouteConfig";

export const certificatesRoute: RouteConfig<'with-page'> = {
    name: 'My Certificates',
    path: '/training/certificates',
    page: lazy(() => import('.')),
    flags: ['member-route'],
    context:'member'
}